import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'light-brand' | 'success' | 'danger' | 'warning' | 'outline-primary' | 'outline-danger';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  icon?: string;
  fullWidth?: boolean;
}

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  icon,
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const sizeClass = size === 'lg' ? 'btn-lg' : size === 'sm' ? 'btn-sm' : '';
  const widthClass = fullWidth ? 'w-100' : '';
  const variantClass = variant === 'light-brand' ? 'btn-light-brand' : `btn-${variant}`;

  return (
    <button
      className={`btn ${variantClass} ${sizeClass} ${widthClass} ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Loading...
        </>
      ) : (
        <>
          {icon && <i className={`feather-${icon} me-2`}></i>}
          {children}
        </>
      )}
    </button>
  );
}

interface SocialButtonProps {
  provider: 'google' | 'facebook' | 'github';
  onClick?: () => void;
  children: React.ReactNode;
}

export function SocialButton({ provider, onClick, children }: SocialButtonProps) {
  const iconMap = {
    google: 'mail',
    facebook: 'facebook',
    github: 'github'
  };

  return (
    <button
      type="button"
      className="btn btn-light-brand flex-fill d-flex align-items-center justify-content-center gap-2"
      onClick={onClick}
    >
      <i className={`feather-${iconMap[provider]}`}></i>
      <span>{children}</span>
    </button>
  );
}
